import './index.scss';

import ImgCobalt from '../../../assets/images/sobre-a-cobalt/quem-somos/img-cobalt@2x.png';

export const Operacional = () => {

    return (
        <div className='teste-cambio'>

            <div className='container-principal operacional'>
                <div className='sombra-title'>
                    <h1> [ Operacional passo-a-passo ] </h1>
                </div>
            </div>

            <div className='restdados-op'>
                <h1>
                    Do cadastro até sua primeira operação com a Cobalt:
                    <br /> <span style={{ fontWeight: 'bold' }}>veja como o processo é simples</span>
                </h1>
            </div>

            <div className='list-itens-op'>
                <div>
                    <span> 01 </span>
                    <p>
                        Após o acordo entre o cliente e a Cobalt, criamos um canal de comunicação. Pela praticidade,
                        utilizamos o <span style={{ fontWeight: 'bold' }}>WhatsApp.</span>
                    </p>
                </div>
                <div>
                    <span> 02 </span>
                    <p>
                        Através deste canal, nosso time solicitará as informações necessárias para a <span style={{ fontWeight: 'bold' }}>abertura de
                            uma conta transitória.</span>
                    </p>
                </div>
                <div>
                    <span> 03 </span>
                    <p>
                        Após a conta aberta e aprovada, nosso time prestará uma consultoria para entender as
                        particularidades de seu negócio. No momento das operações, nossos times de tesouraria e mesa
                        de operações  <span style={{ fontWeight: 'bold' }}> oferecerão a melhor oferta disponível no mercado.</span>
                    </p>
                </div>
                <div>
                    <span> 04 </span>
                    <p>
                        No pós-operacional, nosso time de Middle office fará um acompanhamento minucioso
                        <span style={{ fontWeight: 'bold' }}> desde o
                            fechamento do câmbio até a liquidação da operação.</span>
                    </p>
                </div>
                <div>
                    <span> + </span>
                    <p>
                        Alguns segmentos necessitam do serviço de cobrança.
                        <br /> <span style={{ fontWeight: 'bold' }}>
                            A Cobalt possui uma equipe especializada para atendê-lo.</span>
                    </p>
                </div>
            </div>

            <div className='contact-op'>
                <h1> Fale agora mesmo com um especialista. </h1>
                <button> Agende agora </button>
            </div>
        </div>
    )

}
